import SiteConfigurations from "./SiteConfigurations";

export default SiteConfigurations;
